import React from 'react';
import { WithPluginState } from '@atlaskit/editor-common/with-plugin-state';
import { aiButtonPluginKey } from '../pm-plugins/ai-button/ai-button-plugin-key';
import { aiSpellingGrammarPluginKey } from '../pm-plugins/ai-spelling-grammar/ai-spelling-grammar-plugin-key';
import { createOpenAIModalCommand } from '../pm-plugins/decoration/actions';
import { AtlassianIntelligenceToolbarButton } from '../ui/components/AtlassianIntelligenceToolbarButton/AtlassianIntelligenceToolbarButton';
import { SpellingAndGrammarToolbarButton } from '../ui/components/SpellingAndGrammarToolbarButton/SpellingAndGrammarToolbarButton';
export var getSpellingAndGrammarPrimaryToolbarComponent = function getSpellingAndGrammarPrimaryToolbarComponent(_ref) {
  var editorPluginAIProvider = _ref.editorPluginAIProvider;
  return function (_ref2) {
    var editorView = _ref2.editorView;
    return /*#__PURE__*/React.createElement(WithPluginState, {
      plugins: {
        pluginState: aiSpellingGrammarPluginKey
      },
      render: function render(_ref3) {
        var pluginState = _ref3.pluginState;
        return /*#__PURE__*/React.createElement(SpellingAndGrammarToolbarButton, {
          editorView: editorView,
          aiSpellingGrammarPluginState: pluginState,
          ButtonWrapper: editorPluginAIProvider === null || editorPluginAIProvider === void 0 ? void 0 : editorPluginAIProvider.proactiveAIToolbarButtonWrapper
        });
      }
    });
  };
};
export var getAIPrimaryToolbarComponent = function getAIPrimaryToolbarComponent(_ref4) {
  var api = _ref4.api,
    editorPluginAIProvider = _ref4.editorPluginAIProvider,
    aiGlobalOptIn = _ref4.aiGlobalOptIn;
  return function (_ref5) {
    var editorView = _ref5.editorView;
    return /*#__PURE__*/React.createElement(WithPluginState, {
      plugins: {
        pluginState: aiButtonPluginKey
      },
      render: function render(_ref6) {
        var pluginState = _ref6.pluginState;
        var aiButtonPluginState = pluginState;
        var onClick = function onClick() {
          var state = editorView.state,
            dispatch = editorView.dispatch;
          var configItem = state.selection.empty ? editorPluginAIProvider.emptyConfig.baseGenerate : editorPluginAIProvider.rangeConfig.baseGenerate;
          var openAIModalCommand = createOpenAIModalCommand({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'mainToolbar',
            aiGlobalOptIn: aiGlobalOptIn,
            //TODO: AI Button experiment cleanup - platform_editor_ai_ai_button_block_elements
            triggeredFor: aiButtonPluginState.triggeredFor
          });
          openAIModalCommand(state, dispatch);
        };
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AtlassianIntelligenceToolbarButton, {
          api: api,
          ButtonWrapper: editorPluginAIProvider === null || editorPluginAIProvider === void 0 ? void 0 : editorPluginAIProvider.AIButtonWrapper,
          onClick: onClick,
          disabled: !(aiButtonPluginState !== null && aiButtonPluginState !== void 0 && aiButtonPluginState.isSelectionValidForAIExperience),
          view: editorView
        }));
      }
    });
  };
};